<template>
  <div class="item-box disFlex Flex-center">
    <div class="item-left">
      <img :src="item.cover" class="item-img" @click="viewImg(item.cover)" />
      <div class="item-data disFlex Flex-center fvc">
        已抢
        <span class="num">{{ item.sales }}</span>
        {{ item.pieceUnit.slice(0, 1) }},剩
        <span class="num">{{ item.stock }}</span>
        {{ item.pieceUnit.slice(0, 1) }}
      </div>
    </div>
    <div class="item-right disFlex vertical fbt">
      <div class="item-title clamp1" @click="viewItemInfo">{{ item.name }}</div>
      <div class="item-info-main">
        <img :src="item.brandLogo" class="item-info" />
        <div @click="showPoster()" class="item-info-post">海报分享</div>
      </div>
      <div class="item-detail disFlex Flex-center Flex-between" @click="viewItemInfo">
        <div class="price-area disFlex Flex-center">
          <div class="sale-price" :class="{ 'red-c': stylecolor }">
            ￥{{ item.seckillPrice }}
          </div>
          <div class="origin-price">
            划线价：{{ item.salePrice }}元/{{ item.measureUnit }}
          </div>
        </div>
        <div class="options-area" @click.stop.prevent>
          <div
            class="item-schedule"
            v-if="
              item.status === 'help_success' && item.assist === 0 && source !== 'detail'
            "
            @click="viewDetail(item.id)"
          >
            立即秒杀
          </div>
          <div
            @click="viewDetail(item.id)"
            class="item-schedule"
            v-else-if="
              source !== 'signup' &&
              (item.status === 'sharing' ||
                (item.status === 'help_success' && item.assist > 0))
            "
          >
            <div
              class="item-passed"
              :style="{
                width: `calc(2.13rem * (${
                  item.helpCount || (item.helpUser && item.helpUser.length)
                } / ${item.assist}))`,
              }"
            ></div>
            进度{{ item.helpCount || (item.helpUser && item.helpUser.length) || 0 }}/{{
              item.assist
            }}
          </div>
          <div
            class="item-schedule"
            v-else-if="item.status === 'success' && isself == true"
            @click="getQrCode(item.id)"
          >
            去核销
          </div>
          <div
            class="item-schedule"
            v-else-if="item.status === 'applied'"
            @click="viewDetail(item.id)"
          >
            查看详情
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="infoFlag"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <template>
        <div class="f v info-dialog">
          <div class="info-head f fc">
            <img :src="item.cover" class="info-img" />
            <div class="f v fbt info-detail">
              <div class="name">商品</div>
              <div class="f fc">
                <div class="sale-price" :class="{ 'red-c': stylecolor }">
                  ￥{{ item.seckillPrice }}
                </div>
                <div class="line-price" :class="{ 'red-c': stylecolor }">
                  ￥{{ item.salePrice }}
                </div>
              </div>
              <div class="stock">库存：{{ item.stock }}</div>
            </div>
          </div>
          <div class="info-body">
            <div class="info-item">品牌：{{ item.brandName }}</div>
            <div class="info-item">规格：{{ item.specs }}</div>
            <!-- <div class="f fc info-item">
              <div>描述：</div>
              <div v-html="item.description" class="info-content html-content"></div>
            </div>-->
          </div>
        </div>
      </template>
    </van-dialog>
    <van-dialog
      v-model="qrcodeFlag"
      :close-on-click-overlay="true"
      :show-confirm-button="false"
    >
      <div style="width: 80%; margin: 10px auto">
        <img :src="qrcode" style="width: 100%" alt="图片加载中，请稍后" />
        <div class="tip">出示给导购员进行扫码核销</div>
      </div>
    </van-dialog>
    <!-- 分享二维码海报生成失败的二维码弹窗 -->
    <van-dialog
      v-model="showfailcode"
      confirmButtonText="关闭"
      @confirm="showfailcode = false"
      :close-on-click-overlay="false"
    >
      <div style="width: 80%; margin: 10px auto">
        <img :src="QrCodeAddress" style="width: 100%" alt="图片加载中，请稍后" />
        <div style="text-align: center">分享海报生成出了点差错</div>
        <div style="text-align: center">请长按推广二维码暂时保存</div>
      </div>
    </van-dialog>
    <!-- 查看推广海报内容New版 -->
    <!-- <van-dialog
      v-model="showPosterQr"
      confirmButtonText="关闭"
      @confirm="showPosterQr = false"
      :close-on-click-overlay="false"
    >
      <div class="box">
        <img id="canvas-pic" v-if="canvasFlag" :src="PosterPic" />
      </div>
    </van-dialog> -->
    <div class="newpostcontain" v-if="showPosterQr">
      <div class="newpostcontain-bg" @click="showPosterQr = false"></div>
      <div class="box">
        <img id="canvas-pic" v-if="canvasFlag" :src="PosterPic" />
      </div>
      <div @click.stop="showPosterQr = false" class="close">
        <van-icon name="close" />
      </div>
    </div>
    <!-- 推广海报绘图区域 -->
    <div id="capture2" ref="poster4">
      <div class="bottom_goods">
        <img
          :src="
            GoodPic
              ? GoodPic
              : 'https://j.weizan.cn/city/app/default-pic500.png'
          "
          class="bgposter"
          id="posterDOM"
        />
      </div>
      <div class="bottom_detail fvc fbt">
        <div class="f">
          <div class="title ml10 f v frd" style="height: 150px;">
            <div class="fw600 new-title">{{ item.name }}</div>
            <div style="margin:6px 0">原价 ￥{{ item.salePrice }}</div>
            <div class="fw600" style="color:red;font-size: 16px;margin-bottom: 10px;">秒杀价 ￥{{ item.seckillPrice }}</div>
            <div class="tocode mt5">长按识别二维码 ></div>
            <div style="font-size: 10px;margin-top:3px;color: rgba(0, 0, 0, .5);">查看更多活动优惠</div>
          </div>
        </div>
        <div class="InvitationImg" style="display:none"></div>
        <div class="InvitationImg2 realImage">
          <img :src="posterCode" />
        </div>
      </div>
    </div>
    <div style="display: none;">
      <div id="qrcode-simple"></div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import { delParam } from "@/utils/tools.js";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    source: {
      type: String,
      default: "", // signup 报名弹窗   detail 详情页
    },
    stylecolor: {
      type: Boolean,
      default: true, //风格默认红色
    },
    isself: {
      type: Boolean,
      default: false, //判断是否自己的秒杀商品页面
    },
    ismyseckill: {
      type: Boolean,
      default: false, //判断是否在我的秒杀页面
    },
  },
  data() {
    return {
      imgFlag: false,
      infoFlag: false,
      qrcodeFlag: false,
      qrcode: "",
      // 推广分享秒杀商品海报参数
      showPosterQr: false,
      showfailcode: false,
      canvasFlag: false,
      PosterPic: "",
      GoodPic: "",
      QrCode: "",
      QrCodeAddress: "",
      posterCode: '' // 海报二维码
    };
  },
  methods: {
    viewDetail(id) {
      if (this.item.status === "applied") {
        this.$emit("viewApplyDetail", this.item);
      } else {
        this.$router.push({
          path: this.$utils.getSeckillDetailPath(),
          query: {
            id: id,
            self: true,
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
    },
    getQrCode() {
      this.$http
        .get("/v1/qrcode/gen_code", {
          scene: "seckill_order_finish",
          addition: encodeURIComponent(JSON.stringify({ tradeNo: this.item.tradeNo })),
        })
        .then((res) => {
          this.qrcode = res.data.qrcodePath;
          this.qrcodeFlag = true;
        });
    },
    viewImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    viewItemInfo() {
      this.infoFlag = true;
    },
    // 打开推广海报页面
    async showPoster() {
      this.PosterPic = "";
      this.GoodPic = "";
      this.QrCode = "";
      this.$store.commit("setLoading", true);
      this.canvasFlag = false; //控制canvas元素

      // 商品图赋值
      console.log(this.item.cover);
      this.GoodPic = this.item.cover || "https://j.weizan.cn/city/app/default-pic500.png";


      // let tmp = document.getElementById("posterDOM");
      const goodsimg = new Image();
      goodsimg.setAttribute('crossOrigin', 'anonymous')
      goodsimg.src = this.item.cover + '?v=' + Math.random();
      goodsimg.onload = () => {
        console.log("1-out");
        let base64 = this.getBase64Image(goodsimg);
        this.GoodPic = base64;
      }
      
      // 停顿请求一次
      let qrres = await this.$http.get("/v1/qrcode/gen_code", {
        scene: "promotion_poster",
      });

      console.log("2");
      // 进行分享二维码拼接生成(需要注意!)
      var url = this.handleLink();
      console.log(url);
      this.QrCode = url;
      this.QrCodeAddress = url;
      this.posterCode = ''
      this.$nextTick(function () {
        $(".InvitationImg").html("");
        // $(".InvitationImg2").html("");
        $(".InvitationImg").qrcode({
          render: "canvas", //table方式
          width: 140, //宽度
          height: 140, //高度
          text: url, //任意内容
        });
      });
      // 执行图片转换
      setTimeout(() => {
        var mycanvas = document.getElementsByTagName("canvas")[0];
        console.log(mycanvas);
        var codeimg = mycanvas.toDataURL("image/jpg")
        this.posterCode = codeimg
      }, 1000);
      // 二维码获取完毕，进行拼接
      this.$toast("海报生成中，请稍后");
      setTimeout(() => {
        console.log("success");
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.createCanvas();
      }, 1100);
      // 10秒后若无生成背景图且有二维码的情况下
      // setTimeout(() => {
      //   if (!this.canvasFlag && !this.showPosterQr && this.QrCode) {
      //     console.log("fail");
      //     this.showPosterQr = false;
      //     this.showfailcode = true;
      //     this.$store.commit("setLoading", false);
      //   }
      // }, 10000);
    },
    // 图片库转本地base64
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = 1050;
      canvas.height = 1650;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, 1050, 1650);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      console.log(ext);
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    createCanvas() {
      const that = this;
      var posterdom = that.$refs.poster4;
      html2canvas(posterdom, {
        useCORS: true,
        // width: 320, // 绘制图片的宽 2倍
        // dpi: window.devicePixelRatio * 2, // dpi  如果模糊的话 就把dpi和scale缩放的值调大 dpi越高生成的图片越大
        // height: 568, // 绘制图片的高 2倍
        scale: 3,
      })
        .then(function (canvas) {
          setTimeout(() => {
            that.PosterPic = canvas.toDataURL("image/jpg");
            that.canvasFlag = true;
            that.showPosterQr = true;
            that.$store.commit("setLoading", false);
          });
        })
        .catch((e) => {
          that.$store.commit("setLoading", false);
          console.log(e);
        });
    },
    handleLink() {
      const act_id = localStorage.getItem("act_id");
      const inviteId = localStorage.getItem("inviteId");
      const shop_id = localStorage.getItem("shop_id");
      const brand_id = localStorage.getItem("brand_id");
      const kpi_user_id = localStorage.getItem("kpi_user_id");
      const share_user_id = localStorage.getItem("user_id");
      // const share_user_name = encodeURIComponent(localStorage.getItem("userName"));
      // const share_user_avatar = encodeURIComponent(localStorage.getItem("avatarUrl"));

      let link = location.href;
      if(this.ismyseckill){
        let tmp = this.$utils.getSeckillDetailPath()
        link = location.href.split('?')[0].replace("/my/mySeckill",tmp);//此处需要切换成秒杀详情页的域名地址
      }
      console.log("1", link);
      link = delParam(link, "code");
      link = delParam(link, "state");
      link = delParam(link, "scene");
      link = delParam(link, "action");
      link = delParam(link, "self");
      link = delParam(link, "kpi_user_id");
      link = delParam(link, "share_user_id");
      link = delParam(link, "brand_id");
      link = delParam(link, "inviteId");
      link = delParam(link, "shop_id");
      link = delParam(link, "share_user_name");
      link = delParam(link, "act_id");
      console.log("2", link);
      if (link.indexOf("?") !== -1 && link.indexOf("?") !== location.origin.length + 1) {
        link = link + "&act_id=" + act_id;
      } else {
        link = link + "?act_id=" + act_id;
      }
      if (kpi_user_id && kpi_user_id != 0) {
        link += "&kpi_user_id=" + kpi_user_id;
      }
      if (share_user_id && share_user_id != 0) {
        link += "&share_user_id=" + share_user_id;
      }
      if (inviteId && inviteId != 0) {
        link += "&inviteId=" + inviteId;
      }
      if (shop_id && shop_id != 0) {
        link += "&shop_id=" + shop_id;
      }
      if (brand_id && brand_id != 0) {
        link += "&brand_id=" + brand_id;
      }
      return link;
    },
  },
};
</script>
<style lang="less" scoped>
.red-bgc {
  background: #b80000 !important;
}
.red-bgc-light {
  background: rgba(184, 0, 0, 0.6) !important;
}
.red-c {
  color: #b80000 !important;
}
.white-c {
  color: #ffffff !important;
}
.red-linear {
  background: linear-gradient(90deg, #9b0000, #b80000, #9b0000) !important;
}
.red-boxs {
  box-shadow: 0px 10px 11px 0px rgba(184, 0, 0, 0.68) !important;
}
.item-box {
  width: 100%;
  background: #fff;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f6f7;
  .item-left {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    position: relative;
    .item-img {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }
    .item-data {
      width: 100px;
      height: 22px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.3;
      border-radius: 0 0 5px 5px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      .num {
        color: #fcff00;
      }
    }
  }
  .item-right {
    width: 100%;
    margin-left: 10px;
    height: 100px;
    .item-info-main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item-info-post {
        position: relative;
        width: 80px;
        height: 30px;
        border: 1px solid rgba(0, 48, 120, 1);
        border-radius: 15px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(0, 48, 120, 1);
        line-height: 30px;
        text-align: center;
        z-index: 1;
        top: -1px;
        overflow: hidden;
      }
      .item-info {
        width: 58.5px;
        height: 33px;
        border-radius: 2px;
      }
    }
    .item-title {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
      line-height: 24px;
    }
    .sale-price {
      font-size: 22px;
      font-family: DIN;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
    }
    .origin-price {
      word-break: break-all;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      text-decoration: line-through;
      color: rgba(116, 116, 116, 1);
    }
    .item-schedule {
      position: relative;
      width: 80px;
      height: 30px;
      border: 1px solid rgba(0, 48, 120, 1);
      border-radius: 15px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
      line-height: 30px;
      text-align: center;
      z-index: 1;
      top: -1px;
      overflow: hidden;
      .item-passed {
        background: #ccd6e4;
        height: 30px;
        border-radius: 0 15px 15px 0;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
      }
    }
  }
}
.info-head {
  .info-detail {
    height: 100px;
    text-align: left;
  }
  .info-img {
    width: 100px;
    height: 100px;
    margin: 0 20px;
  }
  .name {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
  .sale-price {
    font-size: 22px;
    font-family: DIN;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
  }
  .line-price {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    text-decoration: line-through;
    color: rgba(116, 116, 116, 1);
  }
  .stock {
    font-size: 16px;
    font-family: DIN;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
}
.info-body {
  padding-left: 20px;
  text-align: left;
  .info-item {
    font-size: 15px;
    font-family: DIN;
    color: rgba(53, 53, 53, 1);
    margin: 10px 0;
  }
  .info-content {
    overflow-x: hidden;
    overflow-y: scroll;
    width: 243px;
    max-height: 30vh;
  }
}
.info-dialog {
  padding: 20px 0 0;
}

// 0.56
#capture2 {
  width: 300px;
  height: 435px;
  position: fixed;
  left: 0;
  top: -9999px;
  // top: 0px;
  margin: 5px auto;
  .bottom_goods {
    width: 300px;
    height: 300px;
    position: absolute;
    left: 50%;
    // top: 10px;
    transform: translate(-50%, 0); /* 50%为自身尺寸的一半 */
    z-index: 11;
    // img {
    //   width: 300px;
    //   height: 300px;
    // }
  }
  .bottom_detail {
    background-color: #fff;
    // border-radius: 5px;
    width: 300px;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0); /* 50%为自身尺寸的一半 */
    z-index: 12;
    // padding: 5px;
  }
  .title {
    font-size: 12px;
    z-index: 11;
    padding: 10px 0;
    align-items: flex-start;
    text-align: left;
    display: flex;    
    justify-content: space-between;
    .new-title{
      font-size: 16px;
      height: 18px;
      line-height: 18px;
      width: 140px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-family:  PingFangSC-Medium, PingFang SC;
    }
  }
  .fw600 {
    font-weight: 600;
  }
  .useravatar {
    width: 60px;
    height: 60px;
    z-index: 11;
    border-radius: 50%;
  }
  .InvitationImg {
    width: 130px;
    height: 130px;
    z-index: 111;
    margin-right: 5px;
  }
  .InvitationImg2 {
    width: 140px;
    height: 140px;
    line-height: 140px;
    z-index: 111;
    margin-right: 5px;
    padding: 3%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bgposter {
    width: 300px;
    height: 300px;
    top: 0px;
    left: 0px;
    position: absolute;
  }
  .tocode {
    font-size: 10px;
    background-color: rgb(245, 245, 245);
    color: rgba(0, 0, 0, .5);
    border-radius: 5px;
    // padding: 2px;
  }
}
.box {
  width: 300px;
  height: 435px;
  z-index: 3;
  position: relative;
  margin: 5px auto;
  #canvas-pic {
    width: 300px;
    height: 435px;
  }
}

.newpostcontain{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .close{
    color: #ffffff;
    margin-top: 10px;
    text-align: center;
    font-size: 30px;
    position: fixed;
    bottom: 58px;
    z-index: 3;
  }
}
.newpostcontain-bg{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.7);
}
</style>
